import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function Dashboard() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) navigate("/");
    else if (user.role === "admin") navigate("/admin");
    else if (user.role === "doctor") navigate("/doctor");
    else if (user.role === "hospital") navigate("/hospital");
    else navigate("/choose-role");
  }, [user, loading, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Loader2 className="w-6 h-6 animate-spin text-sky-600" />
    </div>
  );
}
